import { useQuery } from '@tanstack/react-query'

import { fetchOperationVerificationStatus } from '@/lib/venue/operationVerificationApi'

/**
 * EP-A — 운영 인증 상태 요약 조회(`#778`, 백엔드 `#770`+`#777`).
 * 🚨 게이팅 없음 — `isError`는 진짜 조회 실패(403·404 등)만 뜻한다.
 */
export function useOperationVerificationStatus(venueId: string) {
  return useQuery({
    queryKey: ['venue', venueId, 'operation-verification', 'status'] as const,
    queryFn: () => fetchOperationVerificationStatus(venueId),
  })
}
